import React, {useState, useEffect, useMemo} from 'react'
import { getForms } from '../../../drugData/lookupDrugs';
import { medsCreateState, createMedsStep } from 'store/storeValtio';
import { formData } from '../dropdownOptions';

export default function MedicationForm({prevStep, nextStep}) {
  const [forms, setForms] = useState([]);
  //console.log('MedForm', medsCreateState);

  useEffect(() => {
    const forms = getForms(medsCreateState.orangeId);
    //console.log('forms', forms)
    // if no data from the OrangeBook, use defaults
    if (forms.length === 0) {
      formData.map((f,ix) => forms.push(f.value));
    }
    forms.push('Other');
    setForms(forms);
  },[]);

  function selectForm(n) {
    //console.log('selectForm', n);
    medsCreateState.form = n;
    nextStep(createMedsStep.strength);
  }

  return (
  <>
    <div className='medBody text-center'>
      What is the <b>form</b> of your medication?
    </div>
    <div className='medList'>
      {forms.map((n,ix) => {
        const li = n === medsCreateState.form ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
        return (
          <div
            key={ix} 
            className={'medCard ' + li}
            onClick={()=>selectForm(n)} 
            id={n}>
            {n}
          </div>
          )
        })
      }
    </div>
  </>
  );
}
